import { PersonalAccountItem } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export class PersonalAccountList extends SimpleList<PersonalAccountItem> {}
